// Socket configuration chooser (env-first, runtime fallback).
const DEFAULT_LOCAL_PORT = 8900;

const normalizeBool = (val) =>
  String(val || '')
    .trim()
    .toLowerCase() === 'true';

const normalizePort = (val) => {
  const n = parseInt(String(val || '').trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_LOCAL_PORT;
};

const useLocalFlag = normalizeBool(process.env.REACT_APP_USE_LOCAL_SOCKET);
const localPort = normalizePort(process.env.REACT_APP_LOCAL_SOCKET_PORT);

const normalizeSocketUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^wss?:\/\//i.test(raw)) return raw;
  if (/^https?:\/\//i.test(raw)) {
    return raw.replace(/^http/i, 'ws');
  }
  return raw;
};

const resolveSocketUrl = () => {
  const envUrl = normalizeSocketUrl(process.env.REACT_APP_SOCKET_URL);
  if (envUrl) return envUrl;
  if (typeof window === 'undefined') return '';
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const host = window.location.hostname;
  const port = useLocalFlag ? localPort : window.location.port;
  const portSuffix = port ? `:${port}` : '';
  return `${protocol}://${host}${portSuffix}`;
};

const SOCKET_URL = resolveSocketUrl();

console.log(
  `[socket-config] Using ${SOCKET_URL || 'unset'} (useLocal=${useLocalFlag}, env=${process.env.NODE_ENV})`,
);

export { SOCKET_URL };
export default SOCKET_URL;
